import React, { useState } from 'react'
import { Form } from 'antd'
import QuillInput from './QuillInput'
import { FormInstance } from 'antd/es/form'
import { EmailTemplateResp } from 'types/globalTypes'
import { EventEmailTemplatePayload } from 'types/event/eventStep5'
import { EventResp } from 'types/event/events'
import { creationEventStore } from 'state/event/eventCreationStore'
import {
  useAddEmailTemplateToEvent,
  useUpdateEmailTemplateForEvent,
} from 'api/EmailTemplates/EmailTemplates'
import { myStore } from 'state/store'
import { leagueEventStore } from 'state/league/leagueEvent'

interface EmailBodyProps {
  form: FormInstance
  data: EmailTemplateResp | undefined
  payload: EventEmailTemplatePayload
  organizationId: string
  referenceId: string
  reference: 'event' | 'league' | 'organization' | 'class'
  closeModal: React.Dispatch<React.SetStateAction<boolean>>
}

const EmailBody: React.FC<EmailBodyProps> = ({
  form,
  data,
  payload,
  organizationId,
  referenceId,
  reference,
  closeModal,
}) => {
  const {
    eventData,
    setEventData,
  }: { eventData: EventResp; setEventData: (state: EventResp) => void } =
    creationEventStore(store => ({
      eventData: store.eventData,
      setEventData: store.setEventData,
    }))

  const {
    leagueData,
    setLeagueData,
  }: { leagueData: any; setLeagueData: (state: any) => void } = //tod change the type to exact
    leagueEventStore(store => ({
      leagueData: store.leagueData,
      setLeagueData: store.setLeagueData,
    }))

  const [text, setText] = useState<string>(data ? data.body : '')
  const setModalBtnLoad = myStore(store => store.setModalBtnLoader)

  const { mutate: addEmailTemplateToEvent } = useAddEmailTemplateToEvent()
  const { mutate: updateEmailTemplateForEvent } =
    useUpdateEmailTemplateForEvent()

  const onFinish = () => {
    setModalBtnLoad(true)
    const finalPayload = {
      emailTemplate: {
        ...payload,
        body: text,
        organizationId: organizationId,
      },
    }
    console.log(finalPayload, 'final payload...')
    if (data) {
      updateEmailTemplateForEvent(
        {
          payload: finalPayload,
          referenceId: referenceId,
          templateId: data._id,
          reference: reference === 'event' ? 'organization-events' : 'league',
        },
        {
          onSuccess: newData => {
            setModalBtnLoad(false)
            closeModal(false)
            if (reference === 'event') {
              setEventData({ ...eventData, ...newData } as EventResp)
            } else if (reference === 'league') {
              setLeagueData({ ...leagueData, ...newData } as any)
            }
          },
          onError: () => {
            setModalBtnLoad(false)
          },
        },
      )
    } else {
      addEmailTemplateToEvent(
        {
          payload: finalPayload,
          referenceId: referenceId,
          reference: reference === 'event' ? 'organization-events' : 'league',
        },
        {
          onSuccess: newData => {
            setModalBtnLoad(false)
            closeModal(false)
            if (reference === 'event') {
              setEventData({ ...eventData, ...newData } as EventResp)
            } else if (reference === 'league') {
              setLeagueData({ ...leagueData, ...newData } as any)
            }
          },
          onError: () => {
            setModalBtnLoad(false)
          },
        },
      )
    }
  }

  return (
    <>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <QuillInput text={text} setText={setText} reference={reference} />
      </Form>
    </>
  )
}

export default EmailBody
